import { render, staticRenderFns } from "./UBOTable.vue?vue&type=template&id=6b2e194e&scoped=true&"
import script from "./UBOTable.vue?vue&type=script&lang=ts&"
export * from "./UBOTable.vue?vue&type=script&lang=ts&"
import style0 from "./UBOTable.vue?vue&type=style&index=0&id=6b2e194e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2e194e",
  null
  
)

export default component.exports